"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var Trash = function Trash(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 12 14"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M11.571 1.325H8.357L8.105.843A.646.646 0 0 0 7.53.5H4.468a.638.638 0 0 0-.573.343l-.252.482H.429A.42.42 0 0 0 0 1.737v.825a.42.42 0 0 0 .429.413H11.57A.42.42 0 0 0 12 2.563v-.826a.42.42 0 0 0-.429-.412zM3 5.862a.42.42 0 0 1 .429-.412.42.42 0 0 1 .428.412v5.775a.42.42 0 0 1-.428.413.42.42 0 0 1-.429-.413zm2.571 0A.42.42 0 0 1 6 5.45a.42.42 0 0 1 .429.412v5.775A.42.42 0 0 1 6 12.05a.42.42 0 0 1-.429-.413zm2.572 0a.42.42 0 0 1 .428-.412.42.42 0 0 1 .429.412v5.775a.42.42 0 0 1-.429.413.42.42 0 0 1-.428-.413zm-7.286 6.6c0 .684.575 1.238 1.285 1.238h7.706c.71 0 1.285-.554 1.285-1.237V3.8H.857z"
  })))));
};
var _default = exports.default = Trash;